<template>
  <b-container>
    <!-- {{ options }} -->
    <b-button size="sm" @click="modalOpen">Adicionar BI</b-button>
    <b-modal
      ref="openModal"
      class="filterDateModal"
      scrollable
      title="Selecione o BI"
      @ok="modalOk"
    >
      <label>BI: </label>
      <b-form-select v-model="biId" :options="optionsBi"> </b-form-select>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button variant="green" @click="ok()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "ModuleMenuBiModal",
  components: {
    BaseInputInteger: () =>
      import("@/components_rms/base/BaseInputInteger.vue"),
  },
  props: {
    newField: Array,
    moduleId: String,
    options: Array,
  },
  data: function () {
    return {
      optionsBi: [],
      biId: 0,
      biName: "",
      field: [
        {
          formId: 0,
          powerBiViewId: 0,
          sequenceNumber: 0,
          moduleId: this.id,
        },
      ],
    };
  },
  created() {
    this.getBiDropdown();
  },
  methods: {
    modalOpen() {
      this.$refs.openModal.show();
    },
    getBiDropdown() {
      this.$apiScheduler
        .get("/moduleMenu/dropdownBi/")
        .then((response) => {
          this.optionsBi = response.data;
        })
        .catch((error) => {
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    getBiName() {
      if (this.biId != 0) {
        this.$apiScheduler
          .get("/module/getBiName/" + this.biId)
          .then((response) => {
            this.biName = response.data.sidebarTitle;
          })
          .catch((error) => {
            this.alert.error =
              error.response.status + " - " + error.response.statusText;
            this.$refs.danger.show();
          });
      }
    },
    newModel() {
      this.field.formId = null;
      this.field.powerBiViewId = this.biId;
      this.field.sequenceNumber = 0;
      this.field.moduleId = this.moduleId;
      this.field.formName = null;
      this.field.biName = this.biName;
      this.$emit("update:newField", this.field);
      this.$forceUpdate();
    },
    modalOk() {
      this.newModel();
      this.biId = 0;
      this.biName = "";
      this.field = [];
    },
    removeFromDropdown() {
      let remove = [];
      this.options.forEach((item) => {
        this.optionsBi.forEach((bi) => {
          if (bi.value == item.value) {
            remove.push(bi);
            // console.log(remove);
          }
        });
      });
      remove.forEach((d) => {
        let itemIndex = this.optionsBi.indexOf(d);
          if (itemIndex >= 0) {
          this.optionsBi.splice(itemIndex, 1);
          console.log(this.optionsBi);
        }
      });
      
    },
  },
  watch: {
    biId() {
      this.getBiName();
    },
    options() {
      this.removeFromDropdown();
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>
